export default __webpack_public_path__ + "static/media/servicios4.0e0a7fb6.jpg";